export default __webpack_public_path__ + "static/media/google_calendar.94e015f1.svg";